module.exports = __webpack_public_path__ + "static/media/clinician-watchman-device-400w.c5f71fb7.jpg";